import React from 'react';
import { PhoneCall, ArrowRight } from 'lucide-react';

const CtaBanner = ({ onNavigate }) => {
  const handleSpeakWithMeena = (e) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('contact');
    }
  };

  return (
    <section className="cta-banner-wrapper">
      <div className="cta-banner-container">
        
        {/* Background Wave Graphic / Lines Pattern */}
        <div className="cta-banner-pattern" />

        {/* Left Side: Title & Subtitle */}
        <div className="cta-banner-left">
          <h2 className="cta-banner-heading">
            READY TO SECURE YOUR <span className="heading-serif-italic">FUTURE?</span>
          </h2>
          <p className="cta-banner-subtext">
            Get personalized insurance guidance for your family, financial goals, or business
            needs. Let's find the right solution for your future.
          </p>
        </div>

        {/* Right Side: Action Button */}
        <div className="cta-banner-right">
          <a href="#contact" className="btn-cta-expert" onClick={handleSpeakWithMeena}>
            <PhoneCall size={18} className="btn-phone-icon" />
            <span>Speak with Meena</span>
            <ArrowRight size={18} className="btn-arrow" />
          </a>
        </div>

      </div>
    </section>
  );
};

export default CtaBanner;
